import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M10.125 19a1.625 1.625 0 1 1-3.25 0 1.625 1.625 0 0 1 3.25 0Zm7 0a1.625 1.625 0 1 1-3.25 0 1.625 1.625 0 0 1 3.25 0Zm-7-7a1.625 1.625 0 1 1-3.25 0 1.625 1.625 0 0 1 3.25 0Zm7 0a1.625 1.625 0 1 1-3.25 0 1.625 1.625 0 0 1 3.25 0Zm-7-7a1.625 1.625 0 1 1-3.25 0 1.625 1.625 0 0 1 3.25 0Zm7 0a1.625 1.625 0 1 1-3.25 0 1.625 1.625 0 0 1 3.25 0Z"
    />
  </svg>
`;
